const ContentCell = ({ liveSession, onViewVideo }) => {
    if (liveSession.session_type === 'webinar') return <a href={liveSession.content_url} target="_blank">{liveSession.content_url}</a>
    else if (liveSession.session_type === 'recorded') return <p className="mb-0 fw-semibold text-primary cursor-pointer" onClick={() => onViewVideo(liveSession)}>Video</p>
    
    return <></>
}

export default ContentCell